import { user } from 'ampersand-app'
import request from '@/modules/base/util/request'
import appConfig from '@/modules/apps/config'
import { FineUploaderBasic as Uploader } from 'fine-uploader'
import lang from '@/lang'

import { toast } from '@/modules/base/components/toast/toastConfig'
import { handlePublicApiNotBooked, toUploadError } from '@/modules/apps/util/public-api-error'

/*
 * Actions
 */
const START_FETCHING_APPS_DATA = 'orgamax/apps/START_FETCHING_APPS_DATA'
const FINISHED_FETCHING_APPS_DATA = 'orgamax/apps/FINISHED_FETCHING_APPS_DATA'
const ERROR_FETCHING_APPS_DATA = 'orgamax/apps/ERROR_FETCHING_APPS_DATA'

const START_FETCHING_PUBLISHER_DATA = 'orgamax/apps/START_FETCHING_PUBLISHER_DATA'
const FINISHED_FETCHING_PUBLISHER_DATA = 'orgamax/apps/FINISHED_FETCHING_PUBLISHER_DATA'
const ERROR_FETCHING_PUBLISHER_DATA = 'orgamax/apps/ERROR_FETCHING_PUBLISHER_DATA'

const SET_PATH = 'orgamax/apps/SET_PATH'
const SET_LOADING_MESSAGE = 'orgamax/apps/SET_LOADING_MESSAGE'
const SET_DEVELOPER = 'orgamax/apps/SET_DEVELOPER'
const SET_SEARCH_TEXT = 'orgamax/apps/SET_SEARCH_TEXT'

const START_FETCHING_EDIT_APP = 'orgamax/apps/START_FETCHING_EDIT_APP'
const FINISHED_FETCHING_EDIT_APP = 'orgamax/apps/FINISHED_FETCHING_EDIT_APP'
const ERROR_FETCHING_EDIT_APP = 'orgamax/apps/ERROR_FETCHING_EDIT_APP'

const START_FETCHING_SCOPES = 'orgamax/apps/START_FETCHING_SCOPES'
const FINISHED_FETCHING_SCOPES = 'orgamax/apps/FINISHED_FETCHING_SCOPES'
const ERROR_FETCHING_SCOPES = 'orgamax/apps/ERROR_FETCHING_SCOPES'

const START_FETCHING_DEVELOPER = 'orgamax/apps/START_FETCHING_DEVELOPER'
const FINISHED_FETCHING_DEVELOPER = 'orgamax/apps/FINISHED_FETCHING_DEVELOPER'
const ERROR_FETCHING_DEVELOPER = 'orgamax/apps/ERROR_FETCHING_DEVELOPER'

const START_PERSISTING_APP = 'orgamax/apps/START_PERSISTING_APP'
const FINISHED_PERSISTING_APP = 'orgamax/apps/FINISHED_PERSISTING_APP'
const ERROR_PERSISTING_APP = 'orgamax/apps/ERROR_PERSISTING_APP'

const START_PUBLISHING_APP = 'orgamax/apps/START_PUBLISHING_APP'
const FINISHED_PUBLISHING_APP = 'orgamax/apps/FINISHED_PUBLISHING_APP'
const ERROR_PUBLISHING_APP = 'orgamax/apps/ERROR_PUBLISHING_APP'

const START_FETCHING_DEVELOPERS = 'orgamax/apps/START_FETCHING_DEVELOPERS'
const FINISHED_FETCHING_DEVELOPERS = 'orgamax/apps/FINISHED_FETCHING_DEVELOPERS'
const ERROR_FETCHING_DEVELOPERS = 'orgamax/apps/ERROR_FETCHING_DEVELOPERS'

const START_FETCHING_SHOW_APP = 'orgamax/apps/START_FETCHING_SHOW_APP'
const FINISHED_FETCHING_SHOW_APP = 'orgamax/apps/FINISHED_FETCHING_SHOW_APP'
const ERROR_FETCHING_SHOW_APP = 'orgamax/apps/ERROR_FETCHING_SHOW_APP'
const FINISHED_FETCHING_SHOW_APP_STATUS = 'orgamax/apps/FINISHED_FETCHING_SHOW_APP_STATUS'

const START_UN_INSTALL_APP = 'orgamax/apps/START_UN_INSTALL_APP'
const FINISHED_UN_INSTALL_APP = 'orgamax/apps/FINISHED_UN_INSTALL_APP'
const ERROR_UN_INSTALL_APP = 'orgamax/apps/ERROR_UN_INSTALL_APP'

const SET_MENU_ITEMS = 'orgamax/apps/SET_MENU_ITEMS'
const ADD_MENU_ITEM = 'orgamax/apps/ADD_MENU_ITEM'
const REMOVE_MENU_ITEM = 'orgamax/apps/REMOVE_MENU_ITEM'

const CLEAR_STORE_DATA = 'orgamax/apps/CLEAR_STORE_DATA'

/*
 * Reducer
 */
const initialState = {
  isAppsFetching: false,
  isPublisherFetching: false,
  isEditAppFetching: false,
  isScopesFetching: false,
  isDeveloperFetching: false,
  isAppPersisting: false,
  isAppPublishing: false,
  isDevelopersFetching: false,
  isShowAppFetching: false,
  isUnInstall: false,
  loadingMessage: null,
  publisher: {
    fullName: '',
    street: '',
    postcode: '',
    city: '',
    email: '',
    website: '',
    phone: '',
    agbUrl: '',
  },
  isPublisher: false,
  apps: {
    own: null,
    popular: null,
    new: null,
    features: null,
    all: null,
    published: [],
  },
  path: 'own',
  appsErrorOccured: false,
  publisherErrorOccured: false,
  editAppErrorOccured: false,
  scopesErrorOccured: false,
  developerErrorOccured: false,
  appPersistingErrorOccured: false,
  appPublishingErrorOccured: false,
  developersErrorOccured: false,
  showAppErrorOccured: false,
  unInstallErrorOccured: false,
  editApp: {
    appId: null,
    name: '',
    callbackUrl: '',
    appOpenUrl: '',
    summary: '',
    description: '',
    reviewNotes: '',
    apiKey: '',
    apiSecret: '',
    apiScopes: [],
    images: [],
    icon: '',
    developerId: null,
    development: true,
    pending: false,
    review: false,
    rejected: false,
    approved: false,
    status: '',
  },
  scopes: [],
  developers: {},
  searchText: '',
  showApp: {
    appId: null,
    name: '',
    summary: '',
    description: '',
    images: [],
    icon: null,
    developerId: null,
    isInstalled: null,
  },
  menuItemsAlreadyFetched: false,
  menuItems: [],
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case START_FETCHING_APPS_DATA:
      return Object.assign({}, state, {
        isAppsFetching: true,
      })
    case FINISHED_FETCHING_APPS_DATA:
      const { apps, path: key } = action

      return {
        ...state,
        isAppsFetching: false,
        appsErrorOccured: false,
        apps: { ...state.apps, [key]: apps },
      }
    case ERROR_FETCHING_APPS_DATA:
      return {
        ...state,
        isAppsFetching: false,
        appsErrorOccured: true,
      }

    case START_FETCHING_PUBLISHER_DATA:
      return {
        ...state,
        isPublisherFetching: true,
      }
    case FINISHED_FETCHING_PUBLISHER_DATA:
      const { publisher } = action

      return {
        ...state,
        isPublisherFetching: false,
        publisherErrorOccured: false,
        isPublisher: !!publisher,
        publisher: {
          ...initialState.publisher,
          ...publisher,
        },
      }
    case ERROR_FETCHING_PUBLISHER_DATA:
      return {
        ...state,
        isPublisherFetching: false,
        publisherErrorOccured: true,
      }
    case SET_PATH:
      const { path } = action

      return {
        ...state,
        path,
      }
    case START_FETCHING_EDIT_APP:
      return {
        ...state,
        isEditAppFetching: true,
        loadingMessage: lang.marketplace.messages.appLoading,
      }
    case FINISHED_FETCHING_EDIT_APP:
      const { app: fetchedApp } = action

      return {
        ...state,
        isEditAppFetching: false,
        editAppErrorOccured: false,
        loadingMessage: null,
        editApp: {
          ...initialState.editApp,
          ...fetchedApp,
        },
      }
    case ERROR_FETCHING_EDIT_APP:
      return {
        ...state,
        isEditAppFetching: false,
        editAppErrorOccured: true,
        loadingMessage: null,
      }
    case START_FETCHING_SCOPES:
      return {
        ...state,
        editAppErrorOccured: true,
        isScopesFetching: true,
      }
    case FINISHED_FETCHING_SCOPES:
      const { scopes } = action

      return {
        ...state,
        isScopesFetching: false,
        scopesErrorOccured: false,
        scopes,
      }
    case ERROR_FETCHING_SCOPES:
      return {
        ...state,
        isScopesFetching: false,
        scopesErrorOccured: true,
      }
    case START_FETCHING_DEVELOPER:
      return {
        ...state,
        isDeveloperFetching: true,
      }
    case FINISHED_FETCHING_DEVELOPER:
      const { developer } = action
      return {
        ...state,
        isDeveloperFetching: false,
        developerErrorOccured: false,
        developers: {
          ...state.developers,
          [developer.developerId]: developer,
        },
      }
    case ERROR_FETCHING_DEVELOPER:
      return {
        ...state,
        isDeveloperFetching: false,
        developerErrorOccured: true,
      }
    case START_PERSISTING_APP:
      return {
        ...state,
        isEditAppFetching: true,
        loadingMessage: lang.marketplace.messages.appSaving,
      }
    case FINISHED_PERSISTING_APP:
      const { app: persistedApp } = action

      return {
        ...state,
        isEditAppFetching: false,
        appPersistingErrorOccured: false,
        loadingMessage: null,
        editApp: {
          ...state.editApp,
          ...persistedApp,
        },
      }
    case ERROR_PERSISTING_APP:
      return {
        ...state,
        isEditAppFetching: false,
        appPersistingErrorOccured: true,
        loadingMessage: null,
      }
    case START_PUBLISHING_APP:
      return {
        ...state,
        isAppPublishing: true,
        loadingMessage: lang.marketplace.messages.appSubmit,
      }
    case FINISHED_PUBLISHING_APP:
      const { app: publishedApp } = action

      return {
        ...state,
        isAppPublishing: false,
        appPublishingErrorOccured: false,
        loadingMessage: null,
        editApp: {
          ...state.editApp,
          ...publishedApp,
        },
      }
    case ERROR_PUBLISHING_APP:
      return {
        ...state,
        isAppPublishing: false,
        appPublishingErrorOccured: true,
        loadingMessage: null,
      }
    case SET_LOADING_MESSAGE:
      const { loadingMessage } = action

      return {
        ...state,
        loadingMessage,
      }
    case START_FETCHING_DEVELOPERS:
      return {
        ...state,
        isDevelopersFetching: true,
      }
    case FINISHED_FETCHING_DEVELOPERS:
      return {
        ...state,
        isDevelopersFetching: false,
        developersErrorOccured: false,
      }
    case ERROR_FETCHING_DEVELOPERS:
      return {
        ...state,
        isDevelopersFetching: false,
        developersErrorOccured: true,
      }
    case SET_DEVELOPER:

      const { developerId, data } = action
      return {
        ...state,
        developers: {
          ...state.developers,
          [developerId]: data,
        },
      }
    case SET_SEARCH_TEXT:
      const { searchText } = action

      return {
        ...state,
        searchText,
      }
    case START_FETCHING_SHOW_APP:
      return {
        ...state,
        isShowAppFetching: true,
        loadingMessage: lang.marketplace.messages.appLoading,
      }
    case FINISHED_FETCHING_SHOW_APP:
      const { app: showApp } = action

      return {
        ...state,
        isShowAppFetching: false,
        showAppErrorOccured: false,
        loadingMessage: null,
        showApp: {
          ...initialState.showApp,
          ...showApp,
          isInstalled: null,
        },
      }
    case FINISHED_FETCHING_SHOW_APP_STATUS:
      const { isInstalled } = action

      return {
        ...state,
        showApp: {
          ...state.showApp,
          isInstalled,
        },
        isUnInstall: false,
      }
    case ERROR_FETCHING_SHOW_APP:
      return {
        ...state,
        isShowAppFetching: false,
        showAppErrorOccured: true,
        loadingMessage: null,
      }
    case START_UN_INSTALL_APP:
      const { loadingMessage: unInstallLoadingMessage } = action

      return {
        ...state,
        isUnInstall: true,
        loadingMessage: unInstallLoadingMessage,
      }
    case FINISHED_UN_INSTALL_APP:
      const { isInstalled: installed, callbackUrl } = action

      return {
        ...state,
        isUnInstall: false,
        unInstallErrorOccured: false,
        loadingMessage: null,
        showApp: {
          ...state.showApp,
          isInstalled: installed,
          appOpenUrl: callbackUrl,
        },
      }
    case ERROR_UN_INSTALL_APP:
      return {
        ...state,
        isUnInstall: false,
        unInstallErrorOccured: true,
        loadingMessage: null,
      }
    case SET_MENU_ITEMS:
      const { menuItems } = action

      return {
        ...state,
        menuItems,
        menuItemsAlreadyFetched: true,
      }

    case ADD_MENU_ITEM:
      const { menuItem } = action

      return {
        ...state,
        menuItems: [
          ...state.menuItems,
          menuItem,
        ],
      }

    case REMOVE_MENU_ITEM:
      const { id } = action

      return {
        ...state,
        menuItems: state.menuItems.filter(item => item.appId !== id),
      }

    case CLEAR_STORE_DATA:
      return { ...initialState }

    default:
      return state
  }
}

/*
 * Action Creators
 */
const startFetchingApps = () => ({
  type: START_FETCHING_APPS_DATA,
})

const finishedFetchingApps = ({ path, apps }) => ({
  type: FINISHED_FETCHING_APPS_DATA,
  path,
  apps,
})

const errorFetchingApps = () => ({
  type: ERROR_FETCHING_APPS_DATA,
})

const startFetchingPublisherData = () => ({
  type: START_FETCHING_PUBLISHER_DATA,
})

const finishedFetchingPublisherData = publisher => ({
  type: FINISHED_FETCHING_PUBLISHER_DATA,
  publisher,
})

const errorFetchingPublisherData = () => ({
  type: ERROR_FETCHING_PUBLISHER_DATA,
})

export const setPath = path => ({
  type: SET_PATH,
  path,
})

const startFetchingEditApp = () => ({
  type: START_FETCHING_EDIT_APP,
})

const finishedFetchingEditApp = app => ({
  type: FINISHED_FETCHING_EDIT_APP,
  app,
})

const errorFetchingEditApp = () => ({
  type: ERROR_FETCHING_EDIT_APP,
})

const startFetchingScopes = () => ({
  type: START_FETCHING_SCOPES,
})

const finishedFetchingScopes = scopes => ({
  type: FINISHED_FETCHING_SCOPES,
  scopes,
})

const errorFetchingScopes = () => ({
  type: ERROR_FETCHING_SCOPES,
})

const startFetchingDeveloper = () => ({
  type: START_FETCHING_DEVELOPER,
})

const finishedFetchingDeveloper = developer => ({
  type: FINISHED_FETCHING_DEVELOPER,
  developer,
})

const errorFetchingDeveloper = () => ({
  type: ERROR_FETCHING_DEVELOPER,
})

const startPersistingApp = () => ({
  type: START_PERSISTING_APP,
})

const finishedPersistingApp = app => ({
  type: FINISHED_PERSISTING_APP,
  app,
})

const errorPersistingApp = () => ({
  type: ERROR_PERSISTING_APP,
})

const startPublishingApp = () => ({
  type: START_PUBLISHING_APP,
})

const finishedPublishingApp = app => ({
  type: FINISHED_PUBLISHING_APP,
  app,
})

const errorPublishingApp = () => ({
  type: ERROR_PUBLISHING_APP,
})

const setLoadingMessage = loadingMessage => ({
  type: SET_LOADING_MESSAGE,
  loadingMessage,
})

const startFetchingDevelopers = () => ({
  type: START_FETCHING_DEVELOPERS,
})

const finishedFetchingDevelopers = developers => ({
  type: FINISHED_FETCHING_DEVELOPERS,
  developers,
})

const errorFetchingDevelopers = () => ({
  type: ERROR_FETCHING_DEVELOPERS,
})

const setDeveloper = ({ developerId, data }) => ({
  type: SET_DEVELOPER,
  developerId,
  data,
})

export const setSearchText = ({ searchText }) => ({
  type: SET_SEARCH_TEXT,
  searchText,
})

const startFetchingShowApp = () => ({
  type: START_FETCHING_SHOW_APP,
})

const finishedFetchingShowApp = app => ({
  type: FINISHED_FETCHING_SHOW_APP,
  app,
})

const finishedFetchingShowAppStatus = isInstalled => ({
  type: FINISHED_FETCHING_SHOW_APP_STATUS,
  isInstalled,
})

const errorFetchingShowApp = () => ({
  type: ERROR_FETCHING_SHOW_APP,
})

const startUnInstallApp = loadingMessage => ({
  type: START_UN_INSTALL_APP,
  loadingMessage,
})

const finishedUnInstallStatus = ({ isInstalled, callbackUrl }) => ({
  type: FINISHED_UN_INSTALL_APP,
  isInstalled,
  callbackUrl,
})

const errorUnInstallApp = () => ({
  type: ERROR_UN_INSTALL_APP,
})

const setMenuItems = menuItems => ({
  type: SET_MENU_ITEMS,
  menuItems,
})

const addMenuItem = menuItem => ({
  type: ADD_MENU_ITEM,
  menuItem,
})

const removeMenuItem = id => ({
  type: REMOVE_MENU_ITEM,
  id,
})

const clearStoreData = () => ({
  type: CLEAR_STORE_DATA,
})

export const clearOnUnmount = () => {
  return dispatch => {
    dispatch(clearStoreData())
  }
}

export const fetchPublisher = () => {
  return dispatch => {
    dispatch(startFetchingPublisherData())

    request(appConfig.api.developer, { auth: true, isConcurrent: true })
      .then(({ body: { data } }) => {
        const {
          name: fullName,
          customData,
          email,
        } = data

        dispatch(finishedFetchingPublisherData(
          { ...customData, fullName, email },
        ))
      })
      .catch(() => {
        dispatch(errorFetchingPublisherData())
      })
  }
}

export const putPublisher = data => {
  return async dispatch => {
    dispatch(startFetchingPublisherData())

    try {
      await request(appConfig.api.developer, { data, auth: true, isConcurrent: true, method: 'PUT' })
      dispatch(finishedFetchingPublisherData(data))
    } catch (e) {
      handlePublicApiNotBooked(e)
      dispatch(errorFetchingPublisherData())
    }
  }
}

const resolvePath = path => {
  switch (path) {
    case 'own':
      return 'myApps'
    case 'popular':
      return 'popularApps'
    case 'featured':
      return 'featuredApps'
    case 'new':
    case 'all':
      return 'allApps'
    default:
      return null
  }
}

export const fetchApps = ({ path, searchText }) => {
  return dispatch => {
    dispatch(startFetchingApps())

    const filter = resolvePath(path)

    if (!filter) return

    request(appConfig.api.apps, { data: { filter, searchText }, auth: true, isConcurrent: true })
      .then(({ body: { data: apps } }) => {
        dispatch(finishedFetchingApps({
          path,
          apps: apps.map(app => getPlainShowAppData(app)),
        }))
      })
      .catch((e) => {
        console.error(e)
        dispatch(errorFetchingApps())
      })
  }
}

const getPlainShowAppData = ({
  name: mainName,
  appId,
  developerId,
  ownership: { customData: { callbackUrl: appOpenUrl } } = { customData: {} },
  customData: { name, summary, icon, images = [], description, callbackUrl, isInternalApp },
}) => ({
  developerId,
  name: name ?? mainName,
  summary,
  icon,
  images: (images ?? []).filter(i => !!i),
  description,
  callbackUrl,
  appId,
  appOpenUrl,
  isInternalApp,
})

export const fetchShowApp = id => {
  return dispatch => {
    dispatch(startFetchingShowApp())

    request(appConfig.api.appDetail(id), { auth: true, isConcurrent: true })
      .then(({ body: { data } }) => {
        dispatch(finishedFetchingShowApp(
          getPlainShowAppData(data),
        ))
      })
      .catch(() => {
        dispatch(errorFetchingShowApp())
      })
  }
}

export const fetchShowAppStatus = id => {
  return dispatch => {
    request(appConfig.api.isInstalled(id), { auth: true, isConcurrent: true })
      .then(({ body: { data: { installed } } }) => {
        dispatch(finishedFetchingShowAppStatus(installed))
      })
      .catch(() => {
        dispatch(errorFetchingShowApp())
      })
  }
}

const getPlainEditAppData = ({
  appId,
  version,
  developerId,
  ownership: { customData: { callbackUrl: appOpenUrl } } = { customData: {} },
  customData: { images = [], ...customData },
  status: { value: status },
  isLatestVersion,
},
) => ({
  ...customData,
  appOpenUrl,
  images: (images ?? []).filter(i => !!i),
  appId,
  version,
  developerId,
  development: status === appConfig.status.STATUS_DEVELOPMENT,
  pending: status === appConfig.status.STATUS_PENDING,
  review: status === appConfig.status.STATUS_REVIEW,
  rejected: status === appConfig.status.STATUS_REJECTED,
  approved: status === appConfig.status.STATUS_APPROVED,
  status,
  isLatestVersion,
})

export const fetchPublishedApps = () => {
  return dispatch => {
    dispatch(startFetchingApps())

    request(appConfig.api.developerApps, { auth: true, isConcurrent: true })
      .then(({ body: { data: apps } }) => {
        dispatch(finishedFetchingApps({
          path: 'published',
          apps: apps.map(app => getPlainEditAppData(app)),
        }))
      })
      .catch(() => {
        dispatch(errorFetchingApps())
      })
  }
}

export const createApp = ({ name, callbackUrl }) => {
  return async dispatch => {
    dispatch(startFetchingEditApp())

    try {
      const { body: { data } } = await request(appConfig.api.create, { data: { name, callbackUrl }, auth: true, isConcurrent: true, method: 'POST' })
      dispatch(finishedFetchingEditApp(getPlainEditAppData(data)))
    } catch (e) {
      handlePublicApiNotBooked(e)
      dispatch(errorFetchingEditApp())
      throw e
    }
  }
}

const fetch = ({ id, version }) =>
  request(appConfig.api.app(id, version), { auth: true, isConcurrent: true })

export const fetchDeveloperApp = ({ id, version }) => {
  return dispatch => {
    dispatch(startFetchingEditApp())

    fetch({ id, version })
      .then(({ body: { data } }) => {
        dispatch(finishedFetchingEditApp(
          getPlainEditAppData(data),
        ))
      })
      .catch(() => {
        dispatch(errorFetchingEditApp())
      })
  }
}

export const fetchScopes = () => {
  return dispatch => {
    dispatch(startFetchingScopes())

    request(appConfig.api.scopes, { auth: true, isConcurrent: true, method: 'GET' })
      .then(({ body: { data } }) => {
        dispatch(finishedFetchingScopes(data))
      })
      .catch(() => {
        dispatch(errorFetchingScopes())
      })
  }
}

export const fetchDeveloper = id => {
  return dispatch => {
    dispatch(startFetchingDeveloper())

    request(appConfig.api.developerById(id), { auth: true, isConcurrent: true, method: 'GET' })
      .then(({ body: { data } }) => {
        dispatch(finishedFetchingDeveloper(data))
      })
      .catch(() => {
        dispatch(errorFetchingDeveloper())
      })
  }
}

const persistFile = file => {
  return new Promise((resolve, reject) => {
    const uploader = new Uploader({
      autoUpload: false,
      multiple: false,
      callbacks: {
        onError: (id, name, reason, xhr) => reject(toUploadError(xhr) ?? reason),
        onComplete: (id, name, response, xhr) => resolve({ body: response }),
      },
      request: {
        endpoint: appConfig.api.files,
        customHeaders: { Authorization: `Bearer ${user.token}` },
        inputName: 'image',
      },
    })
    uploader.setParams({ filename: file.name })
    uploader.addBlobs([{ name: file.name, blob: file }])
    uploader.uploadStoredFiles()
  })
}

export const persistApp = ({ appId, version, values, icon, screenshots }) => {
  return async dispatch => {
    dispatch(startPersistingApp())

    try {
      if (icon) {
        dispatch(setLoadingMessage(lang.marketplace.messages.saveIcon))
        const { body: { data: { fileUrl } } } = await persistFile(icon)
        dispatch(setLoadingMessage(null))
        values.icon = fileUrl
      }

      if (screenshots.length) {
        dispatch(setLoadingMessage(lang.marketplace.messages.saveScreenshots))
        const images = await Promise.all(
          screenshots.map(async screenshot => {
            const { body: { data: { fileUrl } } } = await persistFile(screenshot)
            return fileUrl
          }),
        )
        dispatch(setLoadingMessage(null))
        values.images = values.images.concat(images)
      }

      const { body: { data } } = await request(appConfig.api.app(appId, version), { data: values, auth: true, isConcurrent: true, method: 'PUT' })
      const appData = await getPlainEditAppData(data)
      dispatch(finishedPersistingApp(appData))

      return appData
    } catch (e) {
      handlePublicApiNotBooked(e)
      dispatch(errorPersistingApp())
    }
  }
}

export const publishApp = ({ id, version }) => {
  return async dispatch => {
    dispatch(startPublishingApp())

    try {
      await request(appConfig.api.publish(id, version), { auth: true, isConcurrent: true, method: 'POST' })
      const { body: { data } } = await fetch({ id, version })
      dispatch(finishedPublishingApp(
        getPlainEditAppData(data),
      ))
    } catch (e) {
      handlePublicApiNotBooked(e)
      dispatch(errorPublishingApp())
    }
  }
}

export const fetchDevelopers = () => {
  return dispatch => {
    dispatch(startFetchingDevelopers())
    request(appConfig.api.developers, { auth: true, isConcurrent: true, method: 'GET' })
      .then(({ body: { data } }) => {
        data.forEach(app => {
          const { developerId, email, name, customData } = app.developerInfo
          dispatch(setDeveloper({ developerId, data: { ...customData, email, name } }))
        })
        dispatch(finishedFetchingDevelopers())
      })
      .catch(() => {
        dispatch(errorFetchingDevelopers())
      })
  }
}

export const installApp = app => {
  return async dispatch => {
    dispatch(startUnInstallApp(lang.marketplace.messages.appActivating))

    try {
      const { body: { data: { callbackUrl } } } = await request(appConfig.api.install(app.appId), { auth: true, isConcurrent: true, method: 'POST' })
      dispatch(finishedUnInstallStatus({
        callbackUrl,
        isInstalled: true,
      }))

      dispatch(addMenuItem(({ ...app, callbackUrl })))

      toast.showToast({ message: lang.marketplace.messages.appActivatedSuccess })
    } catch (e) {
      dispatch(errorUnInstallApp())
    }
  }
}

export const uninstallApp = id => {
  return async dispatch => {
    dispatch(startUnInstallApp(lang.marketplace.messages.appDeactivating))

    try {
      await request(appConfig.api.uninstall(id), { auth: true, isConcurrent: true, method: 'POST' })
      dispatch(finishedUnInstallStatus({
        callbackUrl: null,
        isInstalled: false,
      }))
      dispatch(removeMenuItem(id))
      toast.showToast({ message: lang.marketplace.messages.appDeactivatedSuccess })
    } catch (e) {
      dispatch(errorUnInstallApp())
    }
  }
}

export const checkResults = (path, alternative) => {
  return dispatch => {
    dispatch(startFetchingApps())

    const filter = resolvePath(path)

    if (!filter) return

    request(appConfig.api.apps, { data: { filter }, auth: true, isConcurrent: true })
      .then(({ body: { data: apps } }) => {
        dispatch(finishedFetchingApps({
          path,
          apps: apps.map(getPlainShowAppData),
        }))

        if (!apps.length) {
          dispatch(setPath(alternative))
        }
      })
      .catch((e) => {
        dispatch(errorFetchingApps())
      })
  }
}

const getAppsMenuItem = ({
  appId,
  name: mainName,
  customData: { name, isInternalApp },
  ownership: { customData: { callbackUrl } },
}) => ({
  appId,
  name: name ?? mainName,
  callbackUrl,
  isInternalApp,
})

export const fetchMenuItems = () => {
  return dispatch => {
    request(appConfig.api.installedApps, { auth: true, isConcurrent: true })
      .then(({ body: { data: apps } }) => {
        dispatch(setMenuItems(apps.map(getAppsMenuItem)))
      })
      .catch()
  }
}
